export const BOOKMAKER_LABELS = {
  betway_bw: 'Betway',
  pstbets_bw: 'PST Bets',
  sunbet_bw: 'Sunbet',
  bet267_bw: 'Bet267',
  bbets_bw: 'BBets',
  betxplosion_bw: 'BetXplosion',
};

export const BOOKMAKER_COLORS = {
  betway_bw: '#00a651',
  pstbets_bw: '#1a56db',
  sunbet_bw: '#f59e0b',
  bet267_bw: '#06b6d4',
  bbets_bw: '#8b5cf6',
  betxplosion_bw: '#ef4444',
};

export function bookmakerLabel(key) {
  return BOOKMAKER_LABELS[key] || key;
}

export function bookmakerColor(key) {
  return BOOKMAKER_COLORS[key] || 'var(--accent)';
}